import { Forecast } from './../classes/weather';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timePipe'
})
export class TimePipePipe implements PipeTransform {

  transform(value: Forecast[]): Forecast[] {

    if (value == null || value === undefined || value.length === 0) {
      return value;
    }

    const arr = [];
    value.forEach(element => {
      if (arr.length < 3 && ( element.Time.getUTCHours() === 6 ||
                              element.Time.getUTCHours() === 12 ||
                              element.Time.getUTCHours() === 18)) {
        arr.push(element);
      }
    });

    return arr;
  }

}
